import HTTPService from "@/core/services/HTTPService";

import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import AuthService from "@/core/services/AuthService";
import ApiService from "@/core/services/ApiService";

export interface User {
  name: string;
  surname: string;
  email: string;
  password: string;
}

export interface UserAuthInfo {
  errors: object;
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = {};
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  public test;
  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_AUTH](user) {
    this.isAuthenticated = true;
    this.user = user;
    this.errors = {};

    JwtService.saveToken(user.authorization.token);
    ApiService.createRequestHandler();

    // AuthService.me();
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
    // TODO write in localstorage
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    JwtService.destroyToken();
  }

  @Action
  [Actions.LOGIN](credentials) {
    return HTTPService.post("login", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_ERROR,
          HTTPService.isValid(response)
            ? response.data.errors
            : HTTPService.serverError()
        );
      });
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.REGISTER](credentials) {
    return HTTPService.post("register", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_ERROR,
          HTTPService.isValid(response)
            ? response.data.errors
            : HTTPService.serverError()
        );
      });
  }

  @Action
  me() {
    return HTTPService.post("me", {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_ERROR,
          HTTPService.isValid(response)
            ? response.data.errors
            : HTTPService.serverError()
        );
      });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    //
  }

  @Action
  async [Actions.VERIFY_AUTH](payload) {
    //
  }
}
